import React, { memo } from 'react';
import PropTypes from 'prop-types';

import AntdDrawer from 'components/Shared/Drawers';
import { injectIntl } from 'react-intl';

import CallTabs from 'components/Shared/Drawers/Sip/CallTabs';

const Phone = memo(({ onClose, intl}) => (
    <AntdDrawer
        isOpen
        hasHorizontalPadding
        hasNoPadding
        onClose={onClose}
        title={intl.formatMessage({ id: 'menuLeft.navigation.phone' })}
        onGoBack={onClose}
        placement="left"
        destroyOnClose
        width={800}
    >
        <CallTabs
            onClose={onClose}
        />
    </AntdDrawer>
));

Phone.propTypes = {
    onClose: PropTypes.func.isRequired,
};

export default memo(injectIntl(Phone));
